<template>
  <div>
    <div class="control-group field">
      <div class="control-label">Presidio</div>
      <div class="controls mychzn-obbligatorio">
        <spinner :visible="!items"></spinner>
        <v-select2
          v-if="items"
          @input="selectItem($event)"
          :disabled="persisted"
          :value="parseInt(id)"
          :options-list="items"
          :selectConfig="getConfig"
          :withCredentials="true"
        ></v-select2>
      </div>
    </div>

    <div class="control-group field obbligatorio">
      <div class="control-label">Data inizio</div>
      <div class="controls mychzn-obbligatorio">
        <datepicker v-model="currentDatein" :disabled="persisted"></datepicker>
      </div>
    </div>

    <div class="control-group field">
      <div class="control-label">Data fine</div>
      <div class="controls">
        <datepicker v-model="currentDateout" :disabled="persisted"></datepicker>
      </div>
    </div>

    <input type="hidden" name="guest_protection[datein]" :value="currentDatein" />
    <input type="hidden" name="guest_protection[dateout]" :value="currentDateout" />
    <div v-if="persisted">Protezione salvata nel magazzino dell'utente</div>
    <div v-else>
      <choose-warehouse-item
        v-if="itemSelected && currentDatein"
        :itemId="itemSelected.id"
        :datein="currentDatein"
        :dateout="currentDateout"
      ></choose-warehouse-item>
    </div>
    <input type="hidden" name="guest_protection[warehouse_protection_id]" :value="itemSelectedValue()" />
    <input type="hidden" name="guest_protection[warehouse_protection_name]" :value="itemSelectedName()" />
  </div>
</template>
<script>
import vSelect2 from '../vSelect2';
import { warehouseApiConnector } from '../../starApiConnector';
import { getCookie } from '../../plugins/userUtils';
import { Route } from '../../route';
import spinner from '../spinner';
import chooseWarehouseItem from './chooseWarehouseItem';
import datepicker from '../datepicker';

export default {
  name: 'guest-protections',
  components: {
    vSelect2,
    spinner,
    chooseWarehouseItem,
    datepicker,
  },
  props: ['id', 'datein', 'dateout'],
  data() {
    return {
      itemSelected: null,
      items: null,
      firstValue: {},
      item_group_cod: 2,
      currentDatein: null,
      currentDateout: null,
    };
  },
  computed: {
    persisted() {
      return this.id ? true : false;
    },
    i18nJS() {
      return window.i18nJS;
    },
    getConfig() {
      return {
        placeholder: `${this.i18nJS.activity.selectEl}`,
        url: `${warehouseApiConnector().defaults.baseURL}/items?item_groups_cods[]=${this.item_group_cod}`,
        headers: {
          'HTTP-X-EPERSONAM-BU-ID': window.config.business_unit.id,
        },
        processResults: this.processResults,
      };
    },
  },
  mounted() {
    this.currentDatein = this.datein || moment().format(i18nJS.time.formats.date_only);
    this.currentDateout = this.dateout;

    warehouseApiConnector()
      .get(`items?item_groups_cods[]=${this.item_group_cod}`)
      .then((response) => {
        this.items = response.data.map((res) => {
          return [res.name, res.id];
        });
      })
      .catch((error) => {
        console.log('error ' + error);
      });
  },
  methods: {
    itemSelectedValue() {
      return this.itemSelected ? this.itemSelected.id : null;
    },
    itemSelectedName() {
      return this.itemSelected ? this.itemSelected.name : null;
    },
    selectItem(item) {
      this.itemSelected = JSON.parse(item);
    },
    processResults(data) {
      if (data) {
        return {
          results: data.map((res) => {
            return { text: res.name, id: JSON.stringify(res) };
          }),
          pagination: {
            more: data.length === 30,
          },
        };
      } else {
        return {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.insert {
  display: flex;
  margin-top: 20px;
  width: 100%;
  align-items: flex-end;
}

.margin-right-10 {
  margin-right: 10px;
}
</style>
